import React, { useEffect, useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Stack,
    Divider,
    Grid,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import CloseIcon from '@mui/icons-material/Close';
import Switch from "../../../../components/form/Switch";

import InputText from "../../../../components/form/InputText";
import Autocomplete from '../../../../components/form/AutoComplete';
import FormatMoney from "../../../../components/form/FormatMoney";
import { PageSize, countPage } from "../../../../config/const";
import SaveIcon from '@mui/icons-material/Save';
import Alert from "../../../../components/form/Alert";
import { useCanView } from "../../../../config/hook/UserPermissions";

import validatorCost from "./validatorCost"
import { postCostProvider } from "../../../../store/masters/thunk/costProvider/post";
import { getConfiCost } from "../../../../store/masters/thunk/costGlobal/getAll";
import { putCostProvider } from "../../../../store/masters/thunk/costProvider/put";
import { getClient } from "../../../../store/masters/thunk/client/getAll";

const CostModal = ({
    __,
    open,
    close,
    selected,
    setSelected,
    reload,
    setError
}) => {
    const idCostProvider = Number(get(selected, "id"));
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const canView = useCanView();

    useEffect(() => {
        dispatch(getConfiCost({ isActive: true, Export: false }));
        dispatch(getClient({ Export: true }));
    }, []);

    const dispatch = useDispatch();
    
    const current = selected
    const provider = useSelector(state => state.masters.provider);

    const put = useSelector(state =>state.masters.costProvider.put);
    const post = useSelector(state => state.masters.costProvider.post);
    const currentProvider = useSelector((state) => state.masters.provider.detail);
    const cost = useSelector((state) => state.masters.costGlobal);
    const userData = JSON.parse(localStorage.getItem('userData'));

    const client = useSelector(state => state.masters.client);

    const clients = map(
        get(client, "data.data", []).filter(c => get(c, "isActive") === "ACTIVO"),
        ({ customerId, name }) => ({
            value: customerId,
            label: `${customerId} - ${name}`,
        })
    );
    
    const divisions = map(userData?.divisions, ({ divisionId, divisionName }) => ({
        value: divisionId,
        label: divisionName,   
    }));
    
    const transportTypes = map(userData?.transportTypes, ({ idTransportType, description }) => ({
        value: idTransportType,
        label: description,
    }));
    
    const costs = map(cost?.data.data, ({ idCost, nameCost }) => ({
        value: Number(idCost),
        label: nameCost,
    }));
  
    const municipalities = map(userData?.municipalities, ({ municipalityId, municipalityName }) => ({
        value: municipalityId,
        label: municipalityName,
    }))

    const onCloseModal = (r) => {
        setSelected({})
        close()
        if (r === "1") {
            reload()
        }
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { onCloseModal("1") }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post"); close(); }
        if (get(put, "isSuccess", false)) { onCloseModal("1") }
        if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put"); close(); }
    }, [post, put])

    const idProvider = Number(get(currentProvider, "data.id"));

    const onSubmit = (values) => {

        const body = {
            id: idCostProvider,
            isAutomatic: Boolean(get(values, "isAutomatic")),
            isFuel: Boolean(get(values, "isFuel")),
            idProvider: Number(idProvider), 
            idTransportType: Number(get(values, "IdTransportType", "")), 
            divisionId: Number(get(values, "division", "")), 
            muniId: Number(get(values, "startDistrict", ""), ""),
            muniIdEnd: Number(get(values, "endDistrict", ""), ""), 
            price: Number(get(values, "price", ""), ""), 
            idCost: Number(get(values, "cost", ""), ""),
            customerId: String(get(values, "customerId", ""))
        }
            
        if (idCostProvider) { 
            if (canView("MAESTROS/PROVEEDORES/COSTOS", "update")) {
                dispatch(putCostProvider(body)) 
            } else {
                setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul> • No tienes permiso para actualizar el costo del proveedor.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                })
            }
        } else { 
            if (canView("MAESTROS/PROVEEDORES/COSTOS", "add")) {
                dispatch(postCostProvider(body)) 
            } else {
                setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul> • No tienes permiso para crear costos al proveedor.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                })
            }
        }
    }
   
    const initialValues = {
        isAutomatic: idCostProvider ? get(current, "isAutomatic", "") : false,
        IdTransportType: idCostProvider ? get(current, "idTransportType", "") : "",
        division: idCostProvider ? get(current, "divisionId", "") : "",
        price: idCostProvider ? get(current, "price", "") : "",
        startDistrict: idCostProvider ? get(current, "muniId", "") : "",
        endDistrict: idCostProvider ? get(current, "muniIdEnd", "") : "",
        cost: idCostProvider ? get(current, "idCost", "") : "",
        isFuel: idCostProvider ? get(current, "isFuel", "") : false,
        customerId: idCostProvider ? get(current, "customerId", "") : "",
    }

    return (
        <div>
            <Dialog onClose={onCloseModal} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {idCostProvider ? __("head.edit.name") : __("head.new.name")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                    {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                                validationSchema={validatorCost(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="provider-cost-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Grid container className='p-4' spacing={2}>
                                                    <Grid item xs={10.3} container justifyContent="right" >
                                                        <Switch formik={formik} name="isFuel" __={__} />
                                                    </Grid>
                                                    <Grid item xs={1.7} container justifyContent="right" >
                                                        <Switch formik={formik} name="isAutomatic" __={__} />
                                                    </Grid>
                                            </Grid>
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            name="cost"
                                                            formik={formik}
                                                            label={__(`form.cost.label`)}
                                                            placeholder={__(`form.cost.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={costs}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="price"
                                                            label={__(`form.price.label`)}
                                                            placeholder={__(`form.price.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            InputProps={{
                                                                inputComponent: FormatMoney,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            name="startDistrict"
                                                            formik={formik}
                                                            label={__(`form.startDistrict.label`)}
                                                            placeholder={__(`form.startDistrict.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={municipalities}
                                                           loading={get(provider, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            name="endDistrict"
                                                            formik={formik}
                                                            label={__(`form.endDistrict.label`)}
                                                            placeholder={__(`form.endDistrict.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={municipalities}
                                                           loading={get(provider, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            formik={formik}
                                                            name="IdTransportType"
                                                            label={__(`form.IdTransportType.label`)}
                                                            placeholder={__(`form.IdTransportType.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={transportTypes}
                                                            loading={get(provider, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            name="division"
                                                            formik={formik}
                                                            label={__(`form.division.label`)}
                                                            placeholder={__(`form.division.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={divisions}
                                                            loading={get(provider, "isLoading")}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <Autocomplete
                                                            name="customerId"
                                                            formik={formik}
                                                            label={__(`form.customerId.label`)}
                                                            placeholder={__(`form.customerId.placeholder`)}
                                                            disabled={get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                            options={clients}
                                                            loading={get(provider, "isLoading")}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" startIcon={<SaveIcon/>} color="secondary" type="submit" form="provider-cost-form" loading={get(post, "isLoading") || get(put, "isLoading")}>{__("action.save")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                </Stack>
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Dialog>
        </div>
    );
}

export default CostModal